import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
    Button,
    Loading
} from "~/components";
import {
    InputField
} from "~/components/Forms";

function ToDoFormRedirectDomain({onHandleSubmit})
{
    const initialValues = {
        fromDomain: "",
        toDomain: ""
    }

    const validationSchema = Yup.object().shape({
        fromDomain: Yup.string().required('Bạn chưa điền Tên miền muốn chuyển hướng'),
        toDomain: Yup.string().required('Bạn chưa điền Tên miền đích đến'),
    })

    const { control, handleSubmit, formState: { isSubmitting, errors }, reset, setValue } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = async (data) => {
        await onHandleSubmit(data);
    }

    return (
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
            {isSubmitting && <Loading/>}
            <Controller control={control} name="fromDomain" render={({field}) => (
                <InputField label="Tên miền muốn chuyển hướng" errors={errors} {...field}/>
            )}/>
            <Controller control={control} name="toDomain" render={({field}) => (
                <InputField label="Tên miền đích đến" errors={errors} {...field}/>
            )}/>
            <hr />
            <div className="form-group d-flex justify-content-end modal-bottom">
                <Button primary type="submit">Tạo yêu cầu</Button>
            </div>
        </form>
    )
}

export default ToDoFormRedirectDomain;